export default defineNuxtRouteMiddleware(async (to) => {
  const localePath = useLocalePath();
  const { checkVerificationToken } = useAuth();
  const { checkChangeMobileToken } = usePostRequests();

  const routeName = ref<string>("");
  if (typeof to.name !== "string" || to.name?.includes("mobile-verification")) {
    routeName.value = "mobile-verification";
  }

  // Function to check if necessary query parameters are present
  const checkQueryParameters = (requiredParams: string[]) => {
    return requiredParams.every((param) => to.query[param] !== undefined);
  };

  // Mapping of route names to required query parameters
  const routeRequirements: { [key: string]: string[] } = {
    "mobile-verification": [
      "mobile",
      "country_id",
      "full_mobile_number",
      "verification_token",
    ],
  };

  // Check if the route requires specific query parameters
  const requiredParams = routeRequirements[routeName.value];
  if (requiredParams && !checkQueryParameters(requiredParams)) {
    return navigateTo(localePath(`/sign-in`));
  }

  if (routeName.value === "mobile-verification") {
    const verificationPlace = useCookie("verificationPlace");
    const {
      mobile,
      country_id,
      verification_token,
      dialing_code,
      deleting_account,
    } = to.query as Record<string, string>;
    const businessIdentifier = to.params.location_identifier;
    const isAccountRoute =
      typeof to.name !== "string" || to.name?.includes("account");

    try {
      if (verificationPlace.value === "change-mobile") {
        await checkChangeMobileToken({
          mobile,
          country_id,
          verification_token,
          dialing_code,
        });
        return;
      }

      if (deleting_account === "true") {
        await $larafetch(
          `/api/${
            useRuntimeConfig().public.apiVersion
          }/account/delete/check-verification-token`,
          {
            method: "POST",
            body: { mobile, country_id, verification_token },
          }
        );
      } else {
        await checkVerificationToken({
          mobile,
          country_id,
          verification_token,
        });
      }
    } catch (err: unknown) {
      console.error(err);

      const targetPath =
        businessIdentifier && !isAccountRoute
          ? `/sign-in`
          : verificationPlace.value === "change-mobile"
          ? "/change-mobile"
          : "/sign-in";

      verificationPlace.value = null;

      return navigateTo(localePath(targetPath));
    }
  }
});
